import { Component, ViewChild } from "@angular/core";
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { environment } from "src/environments/environment";
import { H2ForecastByRegionService } from "./h2-forecast-by-region.service";

@Component({
    selector: 'H2ForecastByRegion',
    templateUrl: './h2-forecast-by-region.component.html',
    styleUrls: ['./h2-forecast-by-region.component.scss']
})

export class H2ForecastByRegionComponent {

    dataSource: any[];
    markers: any[] = [];
    map: google.maps.Map;
    infoWindow: google.maps.InfoWindow;
    regionDataSource: any[];
    reportDataSource: any[];
    mapMarkers: any = [];
    colors: any[];
    size: any[];
    isLoadPanelVisible: boolean = false;
    includeAdditionalData: boolean;
    readonly allowedPageSizes = [10, 20, 50, 100, 200];
    showReport : boolean = false;

    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

    constructor(private notificationService: NotificationService, h2ForecastByRegionService: H2ForecastByRegionService) {
        this.isLoadPanelVisible = true;
        h2ForecastByRegionService.getReportData().subscribe({
            next: data => {
                this.dataSource = data;
                this.regionDataSource = data.map((item) => item.hycoRegions).filter((value, index, self) => self.indexOf(value) === index);
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching H2 Forecast Report", error);
            }
        });
    }

    exportExcel(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'H2ForecastByRegion.xlsx');
                });
        }).then(() => {
        });
        e.cancel = true;
    }

    initMap(): void {
        this.mapMarkers = [];
        const loader = new Loader({
            apiKey: environment.gmaps,
            version: 'weekly'
        });

        loader.load().then((google) => {

            this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
                center: {
                    lat: this.markers[0].latitude,
                    lng: this.markers[0].longitude
                },
                zoom: 4,
                mapTypeId: 'roadmap'
            });

            this.infoWindow = new google.maps.InfoWindow();
            const forecastCategoryLegend = document.getElementById("forecastCategoryLegend") as HTMLElement;
            forecastCategoryLegend.innerHTML = "";
            forecastCategoryLegend.innerHTML = '<b>Color = Forecast Category</b><hr/>'
            const sizeLegend = document.getElementById("sizeLegend") as HTMLElement;
            sizeLegend.innerHTML = "";
            sizeLegend.innerHTML = '<b>Size = H2 Qty (kNm3/h)</b><hr/>';

            let colorcodes = [];

            this.colors.forEach((item, index) => {
                if (colorcodes.indexOf(item.forecastDriverCategoryColor + item.forecastDriver) < 0) {
                    const div = document.createElement("div");
                    div.innerHTML = '<svg height="20" width="20">  <circle cx="10" cy="10" r="' + 6 + '" stroke-width="2" fill="' + item.forecastDriverCategoryColor + '" /> </svg> ' + item.forecastDriver;
                    forecastCategoryLegend.appendChild(div);
                    colorcodes.push(item.forecastDriverCategoryColor + item.forecastDriver);
                }
            });

            let uniqueZize = [];

            this.size.forEach((item, index) => {
                if (item.h2Size && uniqueZize.indexOf(item.h2Size) < 0) {
                    const div = document.createElement("div");
                    div.innerHTML = '<svg height="40" width="40">  <circle cx="20" cy="20" r="' + item.h2Size + '" stroke-width="3" class="blue-circle" /> </svg> ' + item.h2SizeRange;
                    sizeLegend.appendChild(div);
                    uniqueZize.push(item.h2Size)
                }
            })

            for (let i of this.markers) {
                if (i.latitude && i.longitude) {
                    const tempMarker = new google.maps.Marker({
                        position: { lat: i.latitude, lng: i.longitude }, icon: {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: i.h2Size - 3,
                            fillOpacity: 1,
                            strokeColor: i.forecastDriverCategoryColor,
                            fillColor: i.forecastDriverCategoryColor
                        }, map: this.map
                    });
                    tempMarker.addListener('mouseover', ((tempMarker, map, infoWindow) => {
                        return () => {
                            infoWindow.setContent('<p>' + i.company + ', ' + i.city + ', ' + i.province + '</p>');
                            infoWindow.open(map, tempMarker);
                        }
                    })(tempMarker, this.map, this.infoWindow));

                    tempMarker.addListener('mouseout', ((tempMarker, map, infoWindow) => {
                        return () => {

                            infoWindow.close();
                        }
                    })(tempMarker, this.map, this.infoWindow));

                    this.mapMarkers.push(tempMarker);
                }
            }
            new MarkerClusterer({ map: this.map, markers: this.mapMarkers });
        });
    }

    getH2ForecastByRegion(data) {
        this.isLoadPanelVisible = true;

        this.reportDataSource = data;
        this.colors = [];
        this.size = [];
        this.markers = [];

        this.markers = [...data].map(item => item);
        this.colors = data.map(item => <any>{ forecastDriverCategoryColor: item.forecastDriverCategoryColor, forecastDriver: item.forecastDriver })
            .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => (a.forecastDriver > b.forecastDriver ? 1 : -1));
        this.size = data.map(item => <any>{ h2Size: item.h2Size, h2SizeRange: item.h2SizeRange }).sort((a, b) => a.h2Size - b.h2Size);
        this.initMap();
        this.showReport = true;
        this.isLoadPanelVisible = false;
    }

    setAdditionalDataFlag(data) {
        this.includeAdditionalData = data;
    }

}